import { EstablishmentCategory } from '@/modules/accredited-establishments/api/types'
import {
  DEFAULT_LAT,
  DEFAULT_LON,
  DEFAULT_RADIUS_IN_METERS
} from '../../constants/accredited-establishments'

export interface IsDefaultSearchProps {
  categoryIds?: EstablishmentCategory[]
  providerName?: string
  specialtyId?: string
  planId?: string
  addressId?: string
  lat?: string
  lon?: string
  radiusInMeters?: number
}

export interface HasFirstSearchDefaultRadius {
  categoryIds?: EstablishmentCategory[]
  specialtyId?: string
  planId?: string
  lat?: string
  lon?: string
}

export const isDefaultSearch = ({
  categoryIds,
  specialtyId,
  planId,
  addressId,
  providerName,
  lat,
  lon,
  radiusInMeters
}: IsDefaultSearchProps) =>
  (categoryIds === undefined || categoryIds.length === 0) &&
  specialtyId === undefined &&
  planId === undefined &&
  addressId === undefined &&
  providerName === undefined &&
  lat === DEFAULT_LAT &&
  lon === DEFAULT_LON &&
  radiusInMeters === DEFAULT_RADIUS_IN_METERS
